import React from 'react';
import './styles/style.css';
import './styles/normalize.css';
import Auth from './auth/Auth';
import BasicTools from './tools/components/basictools/BasicTools';
import { useSelector } from 'react-redux';
import { account_user } from './store/account/selector.account';
import Main from './app/Main';
import MuiXLicense from './config/MuiXLicense';

function App() {
  const account = useSelector(account_user)

  return (
    <React.Fragment>
      <MuiXLicense />
      <BasicTools />
      {
        account.status && account.token !== null ? 
          <Main />
        : 
          <Auth />
      }

    </React.Fragment>
  );
}

export default App;
